export default __webpack_public_path__ + "static/media/img_support_contact.f3ddcbf3.png";